import React, { useEffect, useState } from "react";
import RecordPage from "../../components/RecordPage";
import api, { errMsg } from "../../core/api";
import { useApp } from "../../core/AppContext";

function ChecklistEditor({ jobId }) {
  const { toast } = useApp();
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!jobId) return;
    api
      .get(`/job-descriptions/${jobId}/checklist`)
      .then((r) => setItems(r.data.items.map((x) => x.title)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [jobId]);

  const add = () => {
    const t = text.trim();
    if (!t) return;
    if (items.length >= 50) return toast("حداکثر ۵۰ آیتم مجاز است", "err");
    setItems((l) => [...l, t]);
    setText("");
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/job-descriptions/${jobId}/checklist`, { items });
      toast("چک‌لیست ذخیره شد");
    } catch (e) {
      toast(errMsg(e), "err");
    } finally {
      setSaving(false);
    }
  };

  if (!jobId)
    return (
      <div className="hint">
        ابتدا وظیفه را ثبت کنید، سپس چک‌لیست اضافه کنید.
      </div>
    );
  if (loading)
    return (
      <div className="empty">
        <div className="spinner" style={{ margin: "0 auto" }} />
      </div>
    );

  return (
    <div className="field" style={{ gridColumn: "1 / -1" }}>
      <label>آیتم‌های چک‌لیست این وظیفه</label>
      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <input
          value={text}
          placeholder="مثلاً: چک کردن کپسول آتش‌نشانی"
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())}
        />
        <button type="button" className="btn btn-ghost" onClick={add}>
          افزودن
        </button>
      </div>
      <div style={{ display: "grid", gap: 6 }}>
        {items.map((t, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              border: "1px solid var(--border)",
              borderRadius: 10,
              padding: "8px 12px",
              background: "var(--card)",
            }}
          >
            <i
              className="fa-solid fa-list-check"
              style={{ color: "var(--primary)" }}
            />
            <span style={{ flex: 1, minWidth: 0 }}>{t}</span>
            <button
              type="button"
              className="icon-btn danger"
              onClick={() => setItems((l) => l.filter((_, j) => j !== i))}
            >
              <i className="fa-solid fa-xmark" />
            </button>
          </div>
        ))}
        {items.length === 0 && (
          <div className="hint">هنوز آیتمی اضافه نشده است.</div>
        )}
      </div>
      <div style={{ marginTop: 10 }}>
        <button type="button" className="btn" onClick={save} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ذخیره چک‌لیست"}
        </button>
      </div>
    </div>
  );
}

export default function Jobs() {
  return (
    <RecordPage
      title="شرح وظایف"
      subtitle="وظایفی که در بخش «وظایف روزانه» به کارکنان تخصیص داده می‌شود"
      endpoint="/job-descriptions"
      createLabel="افزودن وظیفه"
      canCreate
      canEdit
      canDelete
      columns={[
        { key: "title", label: "عنوان وظیفه" },
        {
          key: "description",
          label: "توضیحات",
          render: (r) => (
            <div className="clip" title={r.description || ""}>
              {r.description || "—"}
            </div>
          ),
        },
      ]}
      getFields={(form) => [
        { name: "title", label: "عنوان وظیفه", required: true, full: true },
        { name: "description", label: "توضیحات", type: "textarea" },
        {
          name: "checklistEditor",
          label: "",
          type: "custom",
          full: true,
          noBody: true,
          render: () => <ChecklistEditor jobId={form.id} />,
        },
      ]}
    />
  );
}
